module.exports = __webpack_public_path__ + "img/down-arrow.664dab30.svg";